import {BriefTrackingService} from './../brief/BriefTrackingService';
import briefService from '@/brief-hub/brief/BriefService';
import strategyBriefService from '@/brief-hub/brief/StrategyBriefService';
import {NavigationService} from '@/brief-hub/brief/NavigationService';
import {FreelancerProfileService} from '@/brief-hub/deposit/freelancer/FreelancerProfileService';
import {FreelancerSkillsService} from '@/common/api/FreelancerSkillsService';
import {UserService} from '@/brief-hub/user/UserService';
import {TjmRecommendationService} from '@/brief-hub/deposit/conditions/TjmRecommendationService';
import {LanguagesService} from '@/brief-hub/brief/LanguagesService';
import {CompanyFeesService} from '@/brief-hub/brief/CompanyFeesService';
import {useNavigationStrategyService} from '@/brief-hub/brief/NavigationStrategyService';

export enum DI {
    briefService = 'briefService',
    strategyBriefService = 'strategyBriefService',
    freelancerProfileService = 'freelancerProfileService',
    freelancerSkillsService = 'freelancerSkillsService',
    navigationService = 'navigationService',
    navigationStrategyService = 'navigationStrategyService',
    userService = 'userService',
    tjmRecommendationService = 'tjmRecommendationService',
    languagesService = 'languagesService',
    companyFeesService = 'companyFeesService',
    briefTrackingService = 'briefTrackingService',
}

export function getDIContainer() {
    return {
        [DI.briefService]: briefService,
        [DI.strategyBriefService]: strategyBriefService,
        [DI.freelancerProfileService]: new FreelancerProfileService(),
        [DI.freelancerSkillsService]: new FreelancerSkillsService(),
        [DI.navigationService]: new NavigationService(),
        [DI.navigationStrategyService]: useNavigationStrategyService(),
        [DI.userService]: new UserService(),
        [DI.tjmRecommendationService]: new TjmRecommendationService(),
        [DI.languagesService]: new LanguagesService(),
        [DI.companyFeesService]: new CompanyFeesService(),
        [DI.briefTrackingService]: new BriefTrackingService(),
    };
}
